import { SignedIn, SignedOut, SignIn } from "@clerk/clerk-react";
import { t } from "@lingui/macro";
import { Helmet } from "react-helmet-async";
import { Navigate, useLocation } from "react-router-dom";

import { clearAuthRedirect, useAuthRedirect, withAuthQuery } from "../auth-redirect";
import { PlanIntentSummary } from "../plan-intent-summary";

export const ClerkLoginPage = () => {
  const { search } = useLocation();
  const redirectUrl = useAuthRedirect();

  return (
    <div>
      <Helmet>
        <title>
          {t`Sign in`} - {t`theResume`}
        </title>
      </Helmet>

      <SignedIn>
        <SignedInRedirect to={redirectUrl} />
      </SignedIn>

      <SignedOut>
        <header className="mb-8">
          <h2 className="max-w-[13ch] text-[2rem] font-semibold leading-[1.12] -tracking-wide text-slate-950 [text-wrap:balance] sm:text-[2.25rem]">
            {t`Welcome back to your workspace.`}
          </h2>
          <p className="mt-3 text-base leading-relaxed text-slate-500">
            {t`Sign in to continue where you left off.`}
          </p>
        </header>

        <PlanIntentSummary redirect={redirectUrl} mode="signin" />

        {/* forceRedirectUrl, not a fallback: Clerk must always return here, including after the
            Google round trip, instead of its instance default (the site's home page). */}
        <SignIn
          routing="virtual"
          signUpUrl={withAuthQuery("/auth/register", search)}
          forceRedirectUrl={redirectUrl}
          signUpForceRedirectUrl={redirectUrl}
        />
      </SignedOut>
    </div>
  );
};

/** Already signed in (or just finished): go on, and forget the remembered destination. */
export const SignedInRedirect = ({ to }: { to: string }) => {
  clearAuthRedirect();
  return <Navigate to={to} replace />;
};
